module.exports = __webpack_public_path__ + "img/img2.c299b123.png";